module.exports = __webpack_public_path__ + "bac9efa0c8e5096a881f5857c5a1a51e.svg";